import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../Core/Store";

interface SelectedDateSliceState {
  selectedDate: string;
}

export const initialState: SelectedDateSliceState = {
  selectedDate: null,
};

const selectedDateSlice = createSlice({
  name: "selecteddate",
  initialState,
  reducers: {
    updateSelectedDate: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateSelectedDate } = selectedDateSlice.actions;

export const getSelectedDateSelector = (state: RootState) => state.selecteddate;

export default selectedDateSlice.reducer;
